module.exports = __webpack_public_path__ + "static/img/footImg.ae34e874.png";